export default {
  ans: {
    modal: {
      confirm: 'OK',
      cancel: 'Cancel'
    },
    cascader: {
      placeholder: 'Select',
      noMatch: 'No matching data',
      noData: 'No data'
    },
    datepicker: {
      placeholder: 'Select date',
      cancel: 'Cancel',
      confirm: 'OK',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      selectTime: 'Select time',
      startTime: 'Start time',
      endTime: 'End time'
    },
    input: {
      placeholder: 'Please enter...'
    },
    page: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    poptip: {
      confirm: 'OK',
      cancel: 'Cancel'
    },
    select: {
      placeholder: 'Select',
      noMatch: 'No matching data',
      noData: 'No data',
      search: 'Keyword'
    },
    table: {
      emptyText: 'No data'
    },
    timepicker: {
      clear: 'Clear',
      confirm: 'OK',
      placeholder: 'Select'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/en.js